import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../interface';
import { invalidateNavConfigThunk } from '../thunks/invalidateNavConfig.thunk';
export const initialState = {
  status: RequestStatus.IDLE
};
export const invalidateNavConfigSliceName = 'invalidateNavConfig';
export const {
  actions,
  reducer
} = createSlice({
  name: invalidateNavConfigSliceName,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(invalidateNavConfigThunk.pending, state => {
      state.status = RequestStatus.LOADING;
    });
    builder.addCase(invalidateNavConfigThunk.fulfilled, state => {
      state.status = RequestStatus.SUCCESS;
    });
    builder.addCase(invalidateNavConfigThunk.rejected, state => {
      state.status = RequestStatus.ERROR;
    });
  }
});